import React, { useContext } from 'react';
import { getAuthFooterLinks } from './helpers';
import { InlineList, InlineListItem } from '../InlineList';
import { SMFooterContext } from '../SMFooterContext';
import CopyRight from '../CopyRight';

export interface AuthedFooterLinksProps {
  domain: string;
  lang: string;
}

const AuthedFooterLinks = ({
  domain = 'surveymonkey',
  lang = 'en',
}: AuthedFooterLinksProps) => {
  const { onetrustBannerEnabled } = useContext(SMFooterContext);
  const links = getAuthFooterLinks(domain, lang);
  return (
    <InlineList noMargin>
      {links.map(item => (
        <InlineListItem key={item.title} href={item.url}>
          {item.title}
        </InlineListItem>
      ))}
      <InlineListItem>
        <CopyRight />
      </InlineListItem>
      <If condition={!!onetrustBannerEnabled}>
        {/* Onetrust pipes in the text content here */}
        <InlineListItem
          href="#cookiePreferences"
          className="ot-sdk-show-settings"
          data-testid="AuthedFooterLinks__cookiePreferences"
          lastItem
        />
      </If>
    </InlineList>
  );
};

export default AuthedFooterLinks;
